import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { history } from './history';
import { reducer as toastrReducer } from 'react-redux-toastr';
import { authReducer } from './auth';
import { titleReducer, layoutReducer } from './layout';
import { registeredParticipantsReducer, unregisteredParticipantsReducer } from './participants';
import { publishedReducer, closedReducer, modifyMessageReducer } from './dashboard-messages';
import { siteListReducer, touchpointListReducer, programListReducer, permissionsReducer, touchpointSettingsReducer, demographicsReducer } from './permissions';
import { accessibilityNotificationReducer } from './common';
import { tenantReducer } from './tenantInfo';
import { settingsReducer } from './settings';
import { intakeFormsReducer, modifyIntakeFormReducer, publishIntakeFormReducer, validateIntakeReducer } from './intake';
import { ssgFormsReducer } from "@social-solutions/ssg-forms";
import { participantTypesReducer } from './participant-types';

const rootReducer = combineReducers({
  toastr: toastrReducer,
  accessibilityNotifications : accessibilityNotificationReducer,
  auth: authReducer,
  tenant: tenantReducer,
  router: connectRouter(history),
  title: titleReducer,
  layout: layoutReducer,
  permissions: permissionsReducer,
  sites: siteListReducer,
  forms: touchpointListReducer,
  programs: programListReducer,
  formSettings: touchpointSettingsReducer,
  registeredParticipants : registeredParticipantsReducer,
  unregisteredParticipants : unregisteredParticipantsReducer,
  published : publishedReducer,
  closed : closedReducer,
  modifyMessage : modifyMessageReducer,
  settings : settingsReducer,
  demographics : demographicsReducer,
  intake : intakeFormsReducer,
  modifyIntake : modifyIntakeFormReducer,
  publishIntake : publishIntakeFormReducer,
  validateIntake: validateIntakeReducer,
  ssgForms : ssgFormsReducer,
  participantTypes : participantTypesReducer,
});

export default rootReducer;
